// extracted by mini-css-extract-plugin
export default {"text":"HintOpenStreetRacerFolderAgain_text__setg-"};